import React from "react";

import Layout from "components/Layout";
import Careers from "components/Pages/Careers";

const Page: React.FC<any> = () => {
  return (
    <Layout>
      <Careers />
    </Layout>
  );
};

export default Page;
